import { onBeforeUnmount, onMounted } from "vue";

// Publish the usable content height as a global `--app-h` CSS variable so
// viewport-fit layouts (and all shell heights) work at any container scale.
// On very wide low-DPR displays (4K@100%) `#app` gets a `zoom` for readability
// (see buzztracker.css), and CSS `zoom` distorts `vh` units; dividing the real
// viewport height by #app's zoom yields the height in its own coordinate space,
// which is what every `var(--app-h, 100vh)` reads.
//
// This must run for EVERY layout — not just the authenticated shell — because
// the guest/login/onboarding pages also live inside the zoomed `#app` and rely
// on `--app-h`. Mount it once at the app root.
export function useAppHeight() {
  const update = () => {
    const root = document.getElementById("app");
    const zoom = (root && parseFloat(getComputedStyle(root).zoom)) || 1;
    document.documentElement.style.setProperty(
      "--app-h",
      `${window.innerHeight / zoom}px`,
    );
  };

  onMounted(() => {
    update();
    window.addEventListener("resize", update);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", update);
  });

  return { update };
}
